import * as R from 'ramda';
import Address from './../address';

export default function Partner(data) {
    let partner = data || {};
    this.id = partner.id;
    this.name = R.isNil(partner.name) ? "" : partner.name;
    this.email = R.isNil(partner.email) ? "" : partner.email;
    
    this.partnerInitialReduction = R.isNil(partner.partnerInitialReduction) ? 0 : partner.partnerInitialReduction;
    this.partnerInitialPercentage = R.isNil(partner.partnerInitialPercentage) ? 0 : partner.partnerInitialPercentage;
    this.partnerRecurentReduction = R.isNil(partner.partnerRecurentReduction) ? 0 : partner.partnerRecurentReduction;
    this.partnerRecurentPercentage = R.isNil(partner.partnerRecurentPercentage) ? 0 : partner.partnerRecurentPercentage;
    this.plateformInitialReduction = R.isNil(partner.plateformInitialReduction) ? 0 : partner.plateformInitialReduction;
    this.plateformInitialPercentage = R.isNil(partner.plateformInitialPercentage) ? 0 : partner.plateformInitialPercentage;
    this.plateformRecurentReduction = R.isNil(partner.plateformRecurentReduction) ? 0 : partner.plateformRecurentReduction;
    this.plateformRecurentPercentage = R.isNil(partner.plateformRecurentPercentage) ? 0 : partner.plateformRecurentPercentage;
    this.setupFee = R.isNil(partner.setupFee) ? 0 : partner.setupFee;
    this.personalization = R.isNil(partner.personalization) ? false : partner.personalization;
    this.billingFrequencyInMonths = R.isNil(partner.billingFrequencyInMonths) ? 0 : partner.billingFrequencyInMonths;
    this.color = R.isNil(partner.color) ? "" : partner.color;

    this.numberOfDossiers = R.isNil(partner.numberOfDossiers) ? 0 : partner.numberOfDossiers;

    this.isEnabled = R.isNil(partner.isEnabled) ? true : partner.isEnabled;
    this.fullyQualifiedName = R.isNil(partner.fullyQualifiedName) ? "" : partner.fullyQualifiedName;
    this.vatNumber = R.isNil(partner.vatNumber) ? "" : partner.vatNumber;
    this.siret = R.isNil(partner.siret) ? "" : partner.siret;
    this.addressDataTransferObject = new Address(partner.addressDataTransferObject);
    this.hasLogo = R.isNil(partner.hasLogo) ? false : partner.hasLogo;
}